import React from 'react';

const FONT_REGULAR_S3 = 'https://s3.emmezeta.hr/pwa/fonts/Roboto/roboto-v29-latin-ext_latin-regular.woff2';

/**
 * Preconnect / preload dla LCP (S3, font Roboto z S3)
 */
const PreConnect = () => {
  return (
    <>
      <link rel="preconnect" href="https://omara.cdn-cnj.si" />
      <link rel="preconnect" href="https://apis.google.com" />
      <link rel="preconnect" href="https://s3.emmezeta.hr" crossOrigin="anonymous" />
      <link
        rel="preload"
        href={FONT_REGULAR_S3}
        as="font"
        type="font/woff2"
        crossOrigin="anonymous"
      />
    </>
  );
};

export default PreConnect;
